import { create } from 'zustand';

type ExportFreezeStoreType = {
  isFrozen: boolean;

  freeze: () => void;
  unfreeze: () => void;
};

const useExportFreeze = create<ExportFreezeStoreType>((set, get) => ({
  isFrozen: false,

  freeze: () => {
    if (get().isFrozen) return;
    set({ isFrozen: true });
  },

  unfreeze: () => {
    if (!get().isFrozen) return;
    set({ isFrozen: false });
  },
}));

export const useIsExportFrozen = () =>
  useExportFreeze((state) => state.isFrozen);

export const { getState: getExportFreezeState } = useExportFreeze;
